module.exports = __webpack_public_path__ + "static/img/computer5.d48bad5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-images/computer5.jpg
// module id = lzD9
// module chunks = 0